(ns common.modal.db
  (:require [re-frame.core :as rf]))

(rf/reg-event-db :modal/register
  (fn [db [_ id options content]]
    (assoc-in db [:modal :registry id] (assoc options :content content))))

;; TODO: Unsure if the support for multiple modals is needed or used now.
;; Currently closing a modal should work like this:
;; 1. modal/close is triggered, Dialog is set to open false state
;; 2. modal/closed is triggered when transition is done
;;    - active-modals value is updated
;; 3. ::current-modal value updates and Dialog is set to open true state
;;
;; Alternative implementation could be to render all the active-modals,
;; so they really are open at the same time.
;;
;; To test, open two modals and close them:
;; (do
;;   (rf/dispatch [:modal/open {:id :privacy-modal}])
;;   (rf/dispatch [:modal/open {:id :privacy-modal}]))

(rf/reg-event-fx :modal/open
  (fn [{:keys [db]} [_ {:keys [id on-close on-close-callback props]}]]
    {:db (update-in db [:modal :active-modals]
                    (fnil conj [])
                    {:id id
                     :on-close on-close
                     :on-close-callback on-close-callback
                     :props props
                     :open true})}))

(rf/reg-event-fx :modal/close
  (fn [{:keys [db]} _]
    (let [active-modals (get-in db [:modal :active-modals])
          stack-count (dec (count active-modals))]
      (when (>= stack-count 0)
        {:db (assoc-in db [:modal :active-modals stack-count :open] false)}))))

(rf/reg-fx :modal/execute-callback (fn [cb] (cb)))

(rf/reg-event-fx :modal/closed
  (fn [{:keys [db]} _]
    (let [active-modals (get-in db [:modal :active-modals])
          on-close (:on-close (peek active-modals))
          on-close-callback (:on-close-callback (peek active-modals))
          stack-count (dec (count active-modals))]
      (when (>= stack-count 0)
        {:db (update-in db [:modal :active-modals] pop)
         :fx [(when (some? on-close)
                [:dispatch on-close])
              (when on-close-callback
                [:modal/execute-callback on-close-callback])]}))))

(rf/reg-sub ::current-modal
  (fn [db _]
    (peek (get-in db [:modal :active-modals]))))

(rf/reg-sub :modal/current-id
  :<- [::current-modal]
  (fn [modal _]
    (:id modal)))

(rf/reg-sub :modal/props
  :<- [::current-modal]
  (fn [modal _]
    (:props modal)))

(rf/reg-sub :modal/open
  :<- [::current-modal]
  (fn [modal _]
    (boolean (:open modal))))

(rf/reg-sub :modal/registry
  (fn [db _]
    (get-in db [:modal :registry])))

(rf/reg-sub :modal/current
  :<- [:modal/current-id]
  :<- [:modal/registry]
  (fn [[current-id registry]]
    (get registry current-id)))
